// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.current-square-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing);
}

.current-square {
  max-width: 400px;
  width: 100%;
  display: block;
  border: var(--border-size) var(--border-style) var(--border-color);
  border-radius: var(--box-rounding);
}

.navigation {
  display: flex;
  gap: var(--spacing);
}

.jump-controls {
  display: flex;
  gap: var(--spacing);
  align-items: center;
  margin-top: var(--spacing);
}

.jump-controls input {
  width: var(--input-sm);
}

@media (max-width: 450px) {
  .navigation {
    flex-direction: column;
    align-items: center;
  }

  .jump-controls {
    flex-direction: column;
    gap: var(--spacing-less);
  }

  .current-square {
    max-width: calc(100% - 2 * var(--border-size));
  }
}
`, "",{"version":3,"sources":["webpack://./src/ArtGrid/SquareViewer/SquareViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kEAAkE;EAClE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;EAChD;AACF","sourcesContent":[".current-square-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing);\n}\n\n.current-square {\n  max-width: 400px;\n  width: 100%;\n  display: block;\n  border: var(--border-size) var(--border-style) var(--border-color);\n  border-radius: var(--box-rounding);\n}\n\n.navigation {\n  display: flex;\n  gap: var(--spacing);\n}\n\n.jump-controls {\n  display: flex;\n  gap: var(--spacing);\n  align-items: center;\n  margin-top: var(--spacing);\n}\n\n.jump-controls input {\n  width: var(--input-sm);\n}\n\n@media (max-width: 450px) {\n  .navigation {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .jump-controls {\n    flex-direction: column;\n    gap: var(--spacing-less);\n  }\n\n  .current-square {\n    max-width: calc(100% - 2 * var(--border-size));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
